<app-schedule [listOfEvents]="events"></app-schedule>